<template>
  <div class="page protocol">
    <navigation>服务合同</navigation>

    <section class="content">
      <p class="text tab-2">合同编号：●1</p>
      <p class="text tab-2">借款人：●2</p>
      <p class="text tab-2">身份证号码：●3</p>
      <p class="text tab-2"></p>
      <p class="text tab-2">服务方（或称担保方）：深圳市中资联融资担保有限公司（以下简称：“中资联担保”）</p>
      <p class="text tab-2">地址：深圳市南山区粤海街道科技园社区科苑路11号金融科技大厦25楼(A座)A单元</p>
      <p class="text tab-2"></p>
      <p class="text tab-2">借款人通过业务平台（即展示和签署本协议的APP、H5、小程序等）向青海银行股份有限公司（以下称“青海银行”或“贷款人”）申请贷款，且借款人同意由服务方为本贷款提供连带责任保证担保服务，服务方与借款人就以下事项达成一致，签署本合同：</p>
      <p class="text tab-2"></p>
      <p class="title tab-2">第一条  概述</p>
      <p class="text tab-2">1.本合同与借款人和青海银行签署的编号为●4的《个人借款合同》对应同一单笔贷款。</p>
      <p class="text tab-2">2.本合同未明确的事项，适用《“飞贷”额度借款合同》、《个人借款合同》中相关条款的约定。</p>
      <p class="text tab-2">3.本合同由借款人与服务方自行签署，与青海银行无关。</p>
      <p class="text tab-2"></p>
      <p class="title tab-2">第二条 担保服务与费用</p>
      <p class="text tab-2">
        1.本合同项下借款人应支付担保咨询费，每期担保咨询费与当月应还贷款本息一并支付,担保咨询费金额以贷款金额为基数，按年化担保咨询费率●5%计算，本笔贷款的担保咨询费为人民币（大写）：●6，（小写）：￥●7。第一期担保咨询费金额为人民币●8元，后续每期担保咨询费金额为人民币●9元，若借款人提前结清贷款，则在最后一次还款时一次性支付剩余尚未支付的担保咨询费。
      </p>
      <p class="text tab-2">2.本合同项下担保费按日计算，按照年化担保费率●10%收取，与贷款本息同时支付，按本合同约定的担保日费率、贷款余额和贷款期限按日计算，日担保费率=年化担保费率/360=月担保费率/30；
      </p>
      <p class="text tab-2">
        3. 本合同项下担保服务费以贷款金额为基数按月计算，与贷款本息同时支付，具体收费标准为：月担保服务费=贷款金额×●11%-月担保费。担保服务费至借款合同及本合同项下全部债务清偿之日停止计收，若客户提前还款，当月担保服务费按整期收取。
      </p>
      <p class="text tab-2">
        <strong>4. 贷款期限届满前，借款人可以提前归还贷款本金。服务方届时会根据借款人所提前归还的贷款本金的一定比例收取提前还款管理费。提前还款管理费收取标准和方式会因借款人的贷款类型及实际使用天数有所差异，具体以借款人在申请提前还款时平台所示的金额为准。借款人归还全部应还款项，视为提前还款成功。否则，继续按原还款计划履行还款义务。</strong>
      </p>
      <p class="text tab-2">
        5. 本合同项下，当借款人未按时还款，借款人不可撤销地同意由担保方为借款人代偿应还未还款项。担保方为借款人实施代偿后，即取得其支付的代偿款项部分对应的债权，担保方可就其支付的代偿款项向借款人进行追偿。同时，借款人须向担保方支付代偿费。代偿费以服务方实施代偿的逾期贷款（一笔或多笔）的贷款余额为基数，以代偿费费率为系数，按天计算。
      </p>
      <p class="text tab-2">
        逾期贷款的代偿费计算方式为：代偿费=逾期贷款的贷款余额*∑（各区间代偿费率*各区间对应逾期天数）。逾期天数在10天以内的（含10天），该区间代偿费率为每天●12%；逾期天数在11天至30天的（含30天），该区间代偿费率为每天●13%；逾期天数在30天以上的，该区间代偿费率为每天●14%。
      </p>
      <p class="text tab-2">上述费用收取与青海银行无关。</p>
      <p class="text tab-2">
        6. 担保方按其与贷款人的约定，有义务对借款人在本合同项下的债务予以债权购买（无论是否逾期）或代偿。担保方予以购买债权或代偿后，即取得债权的全部权益，有权向借款人追偿或采取包括但不限于通过债权转让等方式进行催收。本款效力独立于本合同，本合同不成立、不生效、无效、部分无效、被撤销、被解除并不影响本条款的效力。
      </p>
      <p class="text tab-2"></p>
      <p class="title tab-2">第三条 其他</p>
      <p class="text tab-2"><strong>1.双方一致同意本合同由借款人以数据电文形式在“业务平台”上确认即告订立，一经按下述第2项的约定合同生效，双方均接受本合同的约束。</strong></p>
      <p class="text tab-2">2.本合同仅在本合同对应的贷款资金划离贷款人账户之时方始生效。以上划款行为的证明材料以贷款人相关划款凭证为准。</p>
      <p class="text tab-2"></p>
      <p class="text tab-2"></p>
      <p class="text tab-2">借款人：●15</p>
      <p class="text tab-2">签字：●16</p>
      <p class="text tab-2">签署日期：●17</p>
    </section>
  </div>
</template>
<script>
export default {
  name: 'fd-service'
}
</script>
